<template>
  <div class="order" @click="handleClick">
    <span class="order-name">{{ orderName.slice(1) }}</span>
  </div>
</template>

<script>
export default {
  name: "Order",
  props: {
    orderName: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$store.commit("changeRightSheetOp", {
        operacao: this.orderName,
        sequenciada: false
      });
    }
  }
};
</script>

<style scoped>
.order {
  font-size: 0.88rem;
  background: var(--color-blue);
  display: inline-block;
  padding: 1.2em 0.3rem;
  border-radius: 0.2rem;
  min-width: 8rem;
  color: white;
  text-align: left;
  cursor: pointer;
  margin-right: 0.6rem;
  margin-bottom: 0.8rem;
  position: relative;
  user-select: none;
  overflow: hidden;
}
.order-name {
  position: absolute;
  transition: transform 0.3s;
  top: 50%;
  transform: translateY(-50%);
}
</style>
